import React from "react";
import backpanel from "../assets/backpanel.webp";

const Hero = ({ scrollTo }) => (
  <section id="hero" className="text-center py-20 px-4 bg-cover bg-center w-full" style={{ backgroundImage: `url(${backpanel})` }}>
    <div className="bg-black/50 p-8 rounded-xl inline-block">
      <h1 className="text-4xl font-bold text-white">Smarter Fleet Management Solutions</h1>
      <p className="mt-2 text-lg max-w-xl mx-auto text-white">Real-time insights, diagnostics & automation for your entire fleet.</p>
      <button onClick={() => scrollTo("pricing")} className="mt-6 bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded shadow transition duration-300">View Pricing</button>
    </div>
  </section>
);

export default Hero;